export const hasActivePriceProfile = (connectors) =>
  (connectors ?? []).some((connector) => !!connector?.dynamicPricingUuid);
